/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import makeStyles from '@material-ui/core/styles/makeStyles';
import ReactMarkdown from 'react-markdown';
import {
    shape, number, string, bool, func, arrayOf,
} from 'prop-types';
import CUSTOM_BREAKPOINTS from '../../../../../helpers/customBreakpoints';
import { setBrandMovieSkus } from '../../../../../../state/ducks/App/App-Actions';
import { trackEvent } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import MoreMoviesModal from './Partials/MoreMoviesModal';

const useStyles = makeStyles((theme) => ({
    headerTextContainer: {
        width: '80%',
        paddingTop: '2.5%',
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down(CUSTOM_BREAKPOINTS.tabPortrait)]: {
            paddingLeft: '15px',
        },
    },
    imageContainer: {
        width: '10%',
        marginTop: '10px',
        [theme.breakpoints.down(CUSTOM_BREAKPOINTS.tabPortrait)]: {
            paddingTop: '2.5%',
        },
    },
    headerText: {
        fontSize: '14px',
        textAlign: 'center',
        [theme.breakpoints.down(CUSTOM_BREAKPOINTS.tabPortrait)]: {
            textAlign: 'start',
            marginLeft: '10%',
        },

    },
    outerContainer: {
        paddingLeft: '12px',
    },
    skuDescription: {
        fontSize: '12px',
    },
    andMore: {
        fontSize: '12px',
        color: theme.palette.colorPrimary,
        textDecoration: 'underline',
        fontWeight: 'bold',
        cursor: 'pointer',
    },
    skuDescriptionContainer: {
        width: '80%',
        marginTop: '5px',
        [theme.breakpoints.down(CUSTOM_BREAKPOINTS.tabPortrait)]: {
            width: '70%',
        },
    },
    skuPrice: {
        fontWeight: 'bold',
        fontSize: '14px',
    },
    outerPaper: {
        [theme.breakpoints.down(CUSTOM_BREAKPOINTS.tabPortrait)]: {
            marginBottom: '10px',
        },
    },
    linkText: {
        color: theme.palette.colorPrimary,
        textDecoration: 'underline',
        fontSize: '12px',
    },
    linkContainer: {
        textAlign: 'right',
        marginRight: '10px',
        [theme.breakpoints.down(CUSTOM_BREAKPOINTS.tabPortrait)]: {
            marginRight: '25px',
        },
    },
    iconImage: {
        width: '100%',
        [theme.breakpoints.down(CUSTOM_BREAKPOINTS.tabPortrait)]: {
            width: '200%',
        },
    },
}));

const NBCUMovieBanner = ({ skuData, movieSelected, selectMovieSku }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [modalData, changeModalState] = useState(false);
    useEffect(() => {
        const movieSkus = {};
        skuData.products.forEach((product) => {
            movieSkus[product.sku] = true;
        });
        dispatch(setBrandMovieSkus(movieSkus));
    }, []);
    const movieCheckboxOnChange = (e) => {
        if (!movieSelected.skuSelected) {
            selectMovieSku({ skuSelected: skuData?.products?.find((product) => product.sku === e.target.name), error: false });
            dispatch(trackEvent({
                eventCategory: 'Product Page',
                eventAction: 'NBCU Option',
                eventLabel: e.target.name[e.target.name.length - 1] === 'A' ? 'large' : 'small',
            }));
        } else if (movieSelected.skuSelected.sku === e.target.name) {
            selectMovieSku({});
        } else if (movieSelected.skuSelected && movieSelected.skuSelected.sku !== e.target.name) {
            selectMovieSku({ ...movieSelected, error: true });
        }
    };
    return (
        <Paper elevation={3} className={classes.outerPaper}>
            <Grid direction="column" className={classes.outerContainer}>
                <Grid item container>
                    <Grid item className={classes.imageContainer}>
                        <img className={classes.iconImage} src={skuData?.icon?.url} alt={skuData?.icon?.title} />
                    </Grid>
                    <Grid item className={classes.headerTextContainer}>
                        <Grid className={classes.headerText}>
                            <ReactMarkdown source={skuData?.title} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item className={classes.skuInfoContainer}>
                    <FormControl component="fieldset" error={movieSelected.error}>
                        <FormGroup>
                            {skuData?.products?.map((product) => (
                                <Grid container key={product.sku}>
                                    <Grid item>
                                        <FormControlLabel label={<Typography className={classes.skuPrice}>{product.sku_price}</Typography>} control={<Checkbox onChange={movieCheckboxOnChange} checked={movieSelected.skuSelected?.sku === product.sku} name={product.sku} />} />
                                    </Grid>
                                    <Grid item className={classes.skuDescriptionContainer}>
                                        <ReactMarkdown renderers={{ root: 'span', paragraph: 'span' }} source={product.sku_description} className={classes.skuDescription} />
                                        <span>. </span>
                                        <span onClick={() => { changeModalState(product.more_movies); }} onKeyDown={() => {}} className={classes.andMore} role="presentation">See titles.</span>
                                    </Grid>
                                </Grid>
                            ))}
                        </FormGroup>
                        {movieSelected.error && <FormHelperText>Please select only one option</FormHelperText>}
                    </FormControl>
                    <Grid className={classes.linkContainer}>
                        <Link to="/universal-pictures-info">
                            <Typography className={classes.linkText}>
                                Learn more &gt;
                            </Typography>
                        </Link>
                    </Grid>
                </Grid>
            </Grid>
            <MoreMoviesModal modalData={modalData} changeModalState={changeModalState}  />
        </Paper>
    );
};

NBCUMovieBanner.propTypes = {
    movieSelected: shape({
        error: bool,
        skuSelected: shape({
            sku: string.isRequired,
            sku_description: string.isRequired,
            sku_price: number.isRequired,
        }),
    }).isRequired,
    selectMovieSku: func.isRequired,
    skuData: shape({
        icon: shape({
            content_type: string,
            file_size: string,
            filename: string,
            is_dir: bool,
            title: string.isRequired,
            uid: string,
            url: string.isRequired,
        }).isRequired,
        products: arrayOf(
            shape({
                sku: string.isRequired,
                sku_description: string.isRequired,
                sku_price: number.isRequired,
            }).isRequired,
        ).isRequired,
    }).isRequired,
};

export default NBCUMovieBanner;
